import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GenericResponseDto } from '../model/common/generic-response.dto';
import { firstValueFrom, Observable } from 'rxjs';
import { GenerateResponseOtpDto } from '../model/otp-message/generateResponseOtp.dto';
import { GenerateRequestOtpDto } from '../model/otp-message/generateRequestOtp.dto';
import { ValidateRequestOtpDto } from '../model/otp-message/validateRequestOtp.dto';

@Injectable({
  providedIn: 'root'
})
export class SmsOtpService {

  private apiUrl = environment.apiBaseUrl;
    
  constructor(private http: HttpClient) { }

  async generateOtp(requestDto: GenerateRequestOtpDto): Promise<GenericResponseDto<GenerateResponseOtpDto>>{
    return firstValueFrom(
      this.http.post<GenericResponseDto<GenerateResponseOtpDto>>(
      `${this.apiUrl}${environment.services.smsOtp.generateOtp}`, requestDto)
    )
  }

  async validateOtp(requestDto: ValidateRequestOtpDto): Promise<GenericResponseDto<boolean>>{
    return firstValueFrom(
      this.http.post<GenericResponseDto<boolean>>(
      `${this.apiUrl}${environment.services.smsOtp.validateOtp}`, requestDto)
    )
  }

  
}
